module.exports = __webpack_public_path__ + "static/media/psactions_gd.1f1d0193.jpg";